// @ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import groupBy from 'lodash/groupBy';
import React from 'react';
import { jsx } from 'theme-ui';
import useLink from '../../useLink';
import ExhibitorCard from '../ExhibitorsList/ExhibitorCard';
import GroupedExhibitorsCard from '../ExhibitorsList/GroupedExhibitorsCard';

/** @typedef {{  exhibitorId: string; }} Exhibitor */
/**
 * A list of exhibitors, optionally grouped or enhanced.
 * Shadow this to implement grouping and other customizations, like ads.
 *
 * @param {{
 *  exhibitors: Exhibitor[];
 *  group?: any;
 *  groupHeader?: import('../Filters/useIndex').GroupType;
 * }} props
 * */

export default function ExhibitorsPageCards({
  exhibitors,
  group,
  groupHeader,
}) {
  const link = useLink();
  if (Boolean(group)) {
    return (
      <>
        {Object.entries(groupBy(exhibitors, group)).map(([key, exhibitors]) => (
          <GroupedExhibitorsCard
            key={key}
            exhibitors={exhibitors}
            type={groupHeader}
          />
        ))}
      </>
    );
  }

  return (
    <>
      {exhibitors.map((exhibitor) => (
        <ExhibitorCard
          key={exhibitor.exhibitorId}
          to={link.exhibitor(exhibitor)}
          exhibitor={exhibitor}
        />
      ))}
    </>
  );
}
